module.exports = __webpack_public_path__ + "static/media/ios1.b9759f34.jpg";